import Rollbar from 'rollbar';

export const isLogArgument = (value: unknown): value is Rollbar.LogArgument =>
  typeof value === 'undefined' ||
  typeof value === 'string' ||
  typeof value === 'object' ||
  typeof value === 'function';

const env = import.meta.env.MODE;
const enabled = env === 'staging' || env === 'production';
const gitHash = import.meta.env.APP_VERSION;

export const rollbarConfig: Rollbar.Configuration = {
  accessToken: import.meta.env.PROJECT_SERVICE_ROLLBAR_ACCESS_TOKEN,
  autoInstrument: true,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled,
  environment: env,
  hostSafeList: [
    env === 'staging' ? 'www-master.staging.customink.com' : 'customink.com',
  ],
  ignoredMessages: [/BroadcastChannel/, /ttd_dom_ready/, /pinterest/],
  payload: {
    client: {
      javascript: {
        code_version: gitHash,
        guess_uncaught_frames: true,
        source_map_enabled: true,
      },
    },
    code_version: gitHash,
    environment: env,
    server: {
      ...(env === 'staging' ? { branch: import.meta.env.GIT_BRANCH } : {}),
      root: import.meta.env.PROJECT_SERVICE_CART_URL,
    },
  },
};

const rollbarInstance = new Rollbar(rollbarConfig);

const getProxy = () => {
  const methods = [
    'critical',
    'debug',
    'error',
    'info',
    'log',
    'warn',
    'warning',
  ] as const;

  const handler = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(_target: any, logMethod: (typeof methods)[number]) {
      if (!methods.includes(logMethod)) {
        return;
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (message?: string, details?: any) => {
        const options = [
          `%c rollbar ${logMethod}`,
          'color: gray; font-weight: lighter;',
          message,
        ];
        if (details) {
          options.push(details);
        }
        if (import.meta.env.MODE !== 'test') {
          console.log(...options);
        }
      };
    },
  };

  return new Proxy(Rollbar, handler);
};

export const rollbar = enabled ? rollbarInstance : getProxy();
